import client from './client';

export async function list()           { const { data } = await client.get('/api/roles'); return data; }
export async function create(body)     { const { data } = await client.post('/api/roles', body); return data; }
export async function update(id, body) { const { data } = await client.put(`/api/roles/${id}`, body); return data; }
export async function remove(id)       { const { data } = await client.delete(`/api/roles/${id}`); return data; }
